import { useParticipant,  usePubSub } from '@videosdk.live/react-sdk';
import "react-toastify/dist/ReactToastify.css";

const ControlWebCam = ({ localParticipantId }) => {
  // eslint-disable-next-line
  const { participant} = useParticipant(localParticipantId);
  const { sendMessage } = usePubSub('CONTROL_WEBCAM');

  const handleTurnOnCamera = async () => {
    sendMessage({ action: 'turnOnCamera' }, { receiverId: localParticipantId });
  };

  usePubSub('CONTROL_WEBCAM', {
    onMessageReceived: (message) => {
      _handleOnImageCaptureMessageReceived(message);
    },
  });

  const _handleOnImageCaptureMessageReceived = (message) => {
    try {
      if (message.senderId !== localParticipantId && message.message.action === 'turnOnCamera') {
        handleTurnOnCamera();
      }
    } catch (err) {
      console.log("error on image capture", err);
    }
  };

  return (
    <>
    </>
  );
};

export default ControlWebCam;
